import request from '@/utils/request'

let PromotionApi = {
  // =====================等级数据接口start===========================
  /*推广员等级列表*/
  PromotionGrade(data, errorback) {
    return request._post('/shop/user.PromotionGrade/index', data, errorback);
  },
  /*添加数据*/
  PromotionGradeadd(data, errorback) {
    return request._post('/shop/user.PromotionGrade/add', data, errorback);
  },
  /*修改数据*/
  PromotionGradeEdit(data, errorback) {
    return request._post('/shop/user.PromotionGrade/edit', data, errorback);
  },
  /*删除数据*/
  PromotionGradeDel(data, errorback) {
    return request._post('/shop/user.PromotionGrade/del', data, errorback);
  },

  // =====================推广员审核数据接口===========================
  /*申请列表*/
  applyList(data, errorback) {
    return request._post('/shop/user.Promotion/index', data, errorback);
  },
  // 推广员审核
  applyExamine(data, errorback) {
    return request._post('/shop/user.Promotion/examine', data, errorback);
  },
  // 推广员删除
  applyDel(data, errorback) {
    return request._post('/shop/user.Promotion/del', data, errorback);
  },
  // =====================推广员数据接口===========================
  /*推广员用户列表*/
  userList(data, errorback) {
    return request._post('/shop/user.Promotion/userList', data, errorback);
  },
  /*修改数据*/
  PromotionEdit(data, errorback) {
    return request._post('/shop/user.Promotion/edit', data, errorback);
  },
  // 推广员删除
  PromotionuserDel(data, errorback) {
    return request._post('/shop/user.Promotion/userDel', data, errorback);
  },
  // ============推广员设置
  // 推广员设置
  setperson(data, errorback) {
    return request._get('/shop/setting.Promotion/index', data, errorback);
  },
  Psetperson(data, errorback) {
    return request._post('/shop/setting.Promotion/index', data, errorback);
  },
  // ============推广员订单
  getorderPromotion(data, errorback) {
    return request._get('/shop/cash.Promotion/details', data, errorback);
  },
  orderPromotion(data, errorback) {
    return request._post('/shop/cash.Promotion/index', data, errorback);
  },
}
export default PromotionApi;



// WEBPACK FOOTER //
// ./src/api/promotion.js